import { createFileRoute } from '@tanstack/react-router';
import { useProject } from '@/features/projects/use-project';
import { requireReportsFeature } from '@/features/reports/guard';
import { ReportPage } from '@/features/reports/report-page';

/** REP-03..06: one report, also its print view. */
export const Route = createFileRoute('/_app/p/$projectKey/reports/$reportId')({
  beforeLoad: ({ context }) => requireReportsFeature(context.queryClient),
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey, reportId } = Route.useParams();
  const project = useProject(projectKey);
  return <ReportPage project={project} reportId={reportId} />;
}
